import { compose } from 'recompose'
import { connect } from 'react-redux'

import { LOAN_TYPE } from 'src/constants/loan'
import { editLoan, editBalance } from 'src/actions/loan'
import { markLoansChecked } from 'src/actions/homeowner'

import {
  getLoanInterestRate,
  getLoanPrincipalLeft,
  getLoanStatusIsCurrent,
  isUnverified
} from 'src/store/selectors/home/loans'
import { selectHasRefiUPBFeature } from 'src/store/selectors/customerProfile'

const LoanContainer = compose(
  connect(
    (state, loan) => ({
      principalLeft: getLoanPrincipalLeft(loan),
      isCurrent: getLoanStatusIsCurrent(loan),
      hasRefiUPBFeature: selectHasRefiUPBFeature(state)
    }),
    (dispatch, loan) => ({
      editLoan: () => dispatch(editLoan(loan)),
      editBalance: () => dispatch(editBalance(loan)),
      confirmEstimatedRate: () => dispatch(markLoansChecked([loan])),
      interestRate: getLoanInterestRate(loan),
      isHeloc: loan.loanType === LOAN_TYPE.HELOC,
      needsConfirmed: getLoanStatusIsCurrent(loan) && isUnverified(loan)
    })
  )
)

export default LoanContainer
